import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {SetPatientAction} from "../../actions";
import {AuthService, PatientService, UtilService} from "../../services";
import {Store} from "@ngrx/store";
import {Patient} from "../../models";
import {StateService} from "../../services/state/state.service";
import {StateModel} from "../../models/state.model";
import {Location} from "@angular/common";
import * as _ from "lodash";
import {RegexPattern} from "../../models/regex.pattern";

@Component({
  selector: "app-edit-patient-additional-details-modal",
  templateUrl: "./patient-additional-details-modal.component.html",
  styleUrls: ["./patient-additional-details-modal.component.scss"]
})
export class PatientAdditionalDetailsEditModalComponent
  implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("content") template: TemplateRef<any>;

  public states: Array<StateModel> = [];
  public modalRef: any;
  public patient: Patient;
  public regexModel: RegexPattern;

  public nextButtonText: string = "UPDATE PATIENT";

  public modalTitle = "Edit Patient Info";
  public isOfficeStaff: boolean;

  public editMode: boolean = true;

  private patientId: number;
  private isAdminEdit: boolean = false;
  public requestPending: boolean = false;

  public verifyEmail: string;

  private modalOptions: NgbModalOptions = {
    backdrop: "static",
    windowClass: "patient-details",
    container: "app-edit-patient-additional-details-modal",
    keyboard: false
  };

  private patientSnapshot: Patient;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private modalService: NgbModal,
    private utilService: UtilService,
    private stateService: StateService,
    private patientService: PatientService,
    private store: Store<any>,
    private authService: AuthService,
    private location: Location
  ) {
    this.regexModel = new RegexPattern()
  }

  ngOnInit() {
    this.stateService.get().subscribe(value => {
      this.states = value;
    });
    this.store.select("patient").subscribe(patient => {
      const patientModel = new Patient();
      this.patient = Object.assign({}, patientModel, patient);
      this.verifyEmail = this.patient.Email
      // this needs to be handled because now Address1 cannot be empty. For Address = null, it will through Error when editing.
      // same goes for InsurancePolicies
      this.patient.Address = this.patient.Address === null ? patientModel.Address : this.patient.Address;
      this.patient.InsurancePolicies = this.patient.InsurancePolicies.length === 0 ?
        patientModel.InsurancePolicies : this.patient.InsurancePolicies;

      if (this.patient.Id && !this.patientSnapshot) {
        this.patientSnapshot = {...this.patient};
      }
    });

    this.route.parent.parent.data.subscribe(data => {
      if (data.isAdminEdit) {
        this.isAdminEdit = data.isAdminEdit;
        this.nextButtonText = "NEXT";
      }
    });

    this.route.parent.parent.parent.params.subscribe(params => {
      this.patientId = +params["id"];
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalRef = this.modalService.open(this.template, this.modalOptions);
    });
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.modalRef.close();
    });
  }

  checkFormValidity(form) {
    let detectNonAlphaRegex = /[^a-zA-Z]/g;
    return (
      form.invalid ||
      detectNonAlphaRegex.test(this.patient.MiddleName)
    );
  }

  get isButtonEnabled() {
    return true;
  }

  canSkip() {
    return (
      this.patientSnapshot && _.isEqual(this.patient, this.patientSnapshot)
    );
  }

  back() {
    this.location.back();
  }

  skip() {
    this.update();
  }

  update() {
    this.requestPending = true;
    this.patientService.updatePatientProfile(this.patient).subscribe(
      () => {
        this.store.dispatch(
          new SetPatientAction(this.patient, this.utilService)
        );
        this.requestPending = false;
        if (this.isAdminEdit) {
          this.router.navigate(["../billing"], {relativeTo: this.route});
        } else {
          this.router.navigate(["../"], {relativeTo: this.route});
        }
      },
      error => {
        this.requestPending = false;
      }
    );
  }

  stateSelected(value: string) {
    if (value === "none") {
      this.patient.Address.State = "";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/patient-additional-details-modal/patient-additional-details-edit-modal.component.ts